import HeaderMenu from './HeaderMenu.js';
import Footer from './Footer.js';
import Home from './Home.js';
import FadeIn from 'react-fade-in';

import './css/App.css';
import { HashRouter, Routes, Route } from 'react-router-dom';
import LiveTV from './LiveTV.js';
import Podcasts from './Podcasts.js';
import Books from './Books.js';
import Articles from './Articles.js';
import About from './About.js';
import Contact from './Contact.js';

// Hero images for preloading
import { 
  Hero01home, 
  Hero02livetv, 
  Hero03podcast, 
  Hero04books, 
  Hero05articles, 
  Hero06about, 
  Hero07bcontact 
} from './Images.js';
import useHeroImagePreloader from './hooks/useHeroImagePreloader';

//books
import { BookOne, BookTwo, BookThree, BookFour, BookFive, BookSix, BookSeven, BookEight } from './BookData';
import BookCard from './BookCard.js';

function App() {
  // Preload all hero images after first page load
  useHeroImagePreloader([
    Hero01home,
    Hero02livetv,
    Hero03podcast,
    Hero04books,
    Hero05articles,
    Hero06about,
    Hero07bcontact
  ]);

  return (
      <div className="mainbody"> 
        <HeaderMenu />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/livetv" element={<LiveTV />} />
          <Route path="/podcasts" element={<Podcasts />} />
          <Route path="/books" element={<Books />}> 
            <Route path="/books" element={
              <FadeIn>
                <BookCard bookimage={BookOne.image} booktitle={BookOne.title} booksubtitle={BookOne.subtitle} bookdescription={BookOne.desc} booklinks={BookOne.links} />
              </FadeIn>
            } />
            <Route path="/books/bookone" element={
              <FadeIn>
                <BookCard bookimage={BookOne.image} booktitle={BookOne.title} booksubtitle={BookOne.subtitle} bookdescription={BookOne.desc} booklinks={BookOne.links} />
              </FadeIn>
            } />
            <Route path="/books/booktwo" element={
              <FadeIn>
                <BookCard bookimage={BookTwo.image} booktitle={BookTwo.title} booksubtitle={BookTwo.subtitle} bookdescription={BookTwo.desc} booklinks={BookTwo.links} />
              </FadeIn>
            } />
            <Route path="/books/bookthree" element={
              <FadeIn>
                <BookCard bookimage={BookThree.image} booktitle={BookThree.title} booksubtitle={BookThree.subtitle} bookdescription={BookThree.desc} booklinks={BookThree.links} />
              </FadeIn>
            } />
            <Route path="/books/bookfour" element={
              <FadeIn>
                <BookCard bookimage={BookFour.image} booktitle={BookFour.title} booksubtitle={BookFour.subtitle} bookdescription={BookFour.desc} booklinks={BookFour.links} bookextra={BookFour.extra}  />
              </FadeIn>
            } />
            <Route path="/books/bookfive" element={
              <FadeIn>
                <BookCard bookimage={BookFive.image} booktitle={BookFive.title} booksubtitle={BookFive.subtitle} bookdescription={BookFive.desc} booklinks={BookFive.links} bookextra={BookFive.extra}  />
              </FadeIn>
            } />
            <Route path="/books/booksix" element={
              <FadeIn>
                <BookCard bookimage={BookSix.image} booktitle={BookSix.title} booksubtitle={BookSix.subtitle} bookdescription={BookSix.desc} booklinks={BookSix.links} bookextra={BookSix.extra}  />
              </FadeIn>
            } />
            <Route path="/books/bookseven" element={
              <FadeIn>
                <BookCard bookimage={BookSeven.image} booktitle={BookSeven.title} booksubtitle={BookSeven.subtitle} bookdescription={BookSeven.desc} booklinks={BookSeven.links} bookextra={BookSeven.extra}  />
              </FadeIn>
            } />
            <Route path="/books/bookeight" element={
              <FadeIn>
                <BookCard bookimage={BookEight.image} booktitle={BookEight.title} booksubtitle={BookEight.subtitle} bookdescription={BookEight.desc} booklinks={BookEight.links} bookextra={BookEight.extra}  />
              </FadeIn>
            } />
          </Route>
          <Route path="/articles" element={<Articles />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
      </div>
  );
}

export default App;
